import styled from "styled-components";
import { default as BaseLoading } from "../../../common/Loading";

export const Container = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[400]};
  position: relative;
`;

export const Loading = styled(BaseLoading)`
  display: flex;
`;

export const LoadingPins = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.6rem;
  height: 3.6rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  border-radius: 0.3rem;
  position: absolute;
  top: 2rem;
  right: 2rem;
  z-index: 10;
`;
